import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { BiDotsVerticalRounded } from "react-icons/bi";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../store/userSlice";
import axios from "../../../../Global/axios";
import ArrivalListEdit from "./ArrivalListEdit";
import { useNavigate } from "react-router-dom";
import DeleteArrivalList from "./DeleteArrivalList";

const ArrivalList = ({
  titles = [
    "Sl No.",
    "Arrival ID",
    "Arrival Date",
    "Arrival Time",
    "Arrival Sector",
    "Arrival Flight Details",
    "Pickup",
    "Status",
    "Total Candidates",
    "Assign Pickup Person",
    "Action",
  ],
  setUpdateData,
  setShowCandidate,
  filteredListData,
  setSelectedStatus,
  selectedStatus,
  usersData,
}) => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const [EditArrival, setArrivalListEdit] = useState({
    open: false,
    arrivalId: "",
    status: "",
  });

  const { NoDataFound, Pagination, PaginationIndex, Search, currentList } =
    useSearchPagination(filteredListData);

  const SelectPickupPersonHandler = async (value, id) => {
    try {
      const response = await axios.put(
        `/dashboard/arrival-notification/${id}`,
        { user_id: value },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({ msg: response.data.message, color: "bg-green-600" })
        );
        setUpdateData((prev) => !prev);
      }
    } catch (e) {
      dispatch(setAppError({ msg: e.message }));
    }
  };

  const updateState = () => {
    setUpdateData((prev) => !prev);
  };

  return (
    <>
      <div className="pt-2">
        {showPromptElement.open && (
          <DeleteArrivalList
            setUpdateData={setUpdateData}
            showPromptElement={showPromptElement}
            setShowPromptElement={setShowPromptElement}
          />
        )}
        {EditArrival.open && (
          <ArrivalListEdit
            EditArrival={EditArrival}
            candidates={EditArrival.allCandidates}
            setArrivalListEdit={setArrivalListEdit}
            setUpdateData={setUpdateData}
          />
        )}

        <div className="mb-2">
          <label className="mr-2 font-medium" htmlFor="">
            Status
          </label>
          <select
            className="select select-bordered uppercase select-sm"
            name=""
            id=""
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="">All</option>
            <option value="Not Arrived">Not Arrived</option>
            <option value="Arrived">Arrived</option>
          </select>
        </div>

        <div className="flex md:flex-row flex-col  justify-between items-end">
          <Search
            keywords={[
              "arrival_id",
              "arrival_date",
              "arrival_time",
              "sector.name",
              "flight_details",
              "status",
              "user.name",
              "pickup",
            ]}
          />
          <p className="text-sm w-full uppercase text-right font-medium mb-1  block">{`Slide / scroll to right >`}</p>
        </div>
      </div>

      <div className="px-5 pt-10 uppercase bg-white overflow-x-scroll">
        <div
          className={`grid  justify-items-center bg-white   grid-cols-table-arrival-notification  gap-5 p-6    items-baseline w-full   rounded-md `}
        >
          {titles?.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {" "}
              {title}{" "}
            </p>
          ))}
          <NoDataFound />
          {currentList?.length <= 0 && loading && (
            <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-full">
              <p>Loading</p>
              <CgSpinner className="animate-spin" />
            </div>
          )}
          {currentList?.map((listItem, index) => (
            <React.Fragment key={index}>
              <PaginationIndex index={index} />
              <p>{listItem?.arrival_id}</p>
              <p>{listItem?.arrival_date}</p>
              <p>{listItem?.arrival_time}</p>
              <p>{listItem?.sector?.name}</p>
              <p>{listItem?.flight_details}</p>
              <p>{listItem?.pickup ? listItem?.pickup : "---"}</p>
              <p>{listItem?.status ? listItem?.status : "---"}</p>
              <p>{listItem?.candidate?.length}</p>
              <select
                className="select select-sm  uppercase select-bordered"
                name=""
                id=""
                value={listItem?.user_id}
                onChange={(e) =>
                  SelectPickupPersonHandler(e.target.value, listItem?.id)
                }
              >
                {usersData?.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              <div className="relative">
                <button className="rounded-md bg-white p-2 text-sm text-black peer ">
                  <BiDotsVerticalRounded size={"1.4rem"} />
                </button>

                <div className="hidden absolute bottom-0 right-7 max-w-xs w-[17rem] h-auto bg-white shadow-xl rounded-lg p-2 dark:bg-dark2 ring-1 ring-slate-400 dark:ring-black peer-hover:block hover:block">
                  <button
                    className="w-full"
                    onClick={() =>
                      setArrivalListEdit({
                        open: true,
                        arrivalId: listItem?.id,
                        status: listItem?.status,
                      })
                    }
                  >
                    <p className="bg-white shadow-sm uppercase  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                      Edit
                    </p>
                  </button>

                  <button
                    onClick={() =>
                      setShowPromptElement({ open: true, id: listItem?.id })
                    }
                    className="w-full"
                  >
                    <p className="bg-white shadow-sm uppercase p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red text-left">
                      Delete
                    </p>
                  </button>
                  {listItem?.candidate?.length > 0 && (
                    <button
                      className="w-full"
                      onClick={() => {
                        navigate(
                          `/dashboard/arrival-notification/${listItem?.id}/candidates`
                        );
                        setShowCandidate({
                          open: true,
                          candidate: listItem?.candidate,
                          arrivalId: listItem?.id,
                        });
                      }}
                    >
                      <p className="bg-white uppercase p-2 w-full hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                        Candidates
                      </p>
                    </button>
                  )}
                </div>
              </div>

              <hr className="border-[1.5px] border-slate-100  w-full col-span-full" />
            </React.Fragment>
          ))}
        </div>
      </div>
      <Pagination />
    </>
  );
};

export default ArrivalList;
